export const AMEX_CARD_TYPE = 'amex';
export const UNKNOWN_CARD_TYPE = 'unknown';
